import type { ComponentPropsOptions } from "vue";
import type { InfoProps } from "../info/Info";
import { defineComponent } from "vue";
import { cn } from "@/utils/cn";
import { p } from "@/utils/props-builder";
import Icon from "../icon/Icon";
import Info from "../info/Info";
import Tooltip from "../tooltip/Tooltip";

export const labelProps = {
  label: p.string(),
  id: p.string(() => {
    const suffix = Math.random().toString(36).slice(2, 11);
    return "label-" + suffix;
  }),
  required: p.boolean(),
  tooltip: p.string(),
  info: p.object<InfoProps>(),
} satisfies ComponentPropsOptions;

export default defineComponent({
  name: "Label",
  props: labelProps,
  setup(props, { slots, attrs }) {
    return () => (
      <label
        for={props.id}
        id={`${props.id}-label`}
        class={cn("flex items-center px-1 pb-1 text-[13px] text-foreground", attrs.class ?? "")}
      >
        {slots.default?.() ?? props.label}
        {props.required && (
          <span class="mb-1 ml-1 inline whitespace-nowrap text-xs text-red-11" aria-hidden="true">
            *
          </span>
        )}
        {props.required && <span class="sr-only">(required)</span>}
        {props.tooltip && (
          <span class="ml-1">
            <Tooltip text={props.tooltip} align="start" class="w-72">
              <Icon
                icon="lucide:help-circle"
                class="h-3 w-3 cursor-help opacity-70 transition hover:opacity-100"
              />
            </Tooltip>
          </span>
        )}
        {props.info && <Info {...props.info} />}
      </label>
    );
  },
});
